import "./style.scss"
import Header from "../header/Heade";
import Navbar from "../Navbar/Navbar";
import Footer from "../footer/Footer";
import React, {Suspense, useEffect} from "react";
import Aos from "aos";
import 'react-bootstrap-typeahead/css/Typeahead.css';
import Seo from "../Seo";
import Loader from "../loader/Loader";
const LazyQuote = React.lazy(() => import("../quote/Quote"));

const GetQuote = () => {
    useEffect(() => {
        Aos.init({duration: 1000});
    }, []);


    return <div className="get-quote-container">
        <Seo title="Get a Free Car Shipping Quote | Leader Auto Ship"
             description="Get a free car shipping quote. Enter pickup and delivery locations and your vehicle, and a Leader Auto Ship advisor sends your price."
             path="/get-quote"/>
        <header>
            <Header/>
            <Navbar/>
        </header>
        <main>
            <h1 className="visually-hidden">Get a Free Car Shipping Quote</h1>
            <section data-aos="flip-right" className="get-quote-card">
                <Suspense fallback={<Loader/>}>
                    <LazyQuote/>
                </Suspense>
            </section>
        </main>
        <footer>
            <Footer/>
        </footer>
    </div>
};

export default GetQuote